import React from 'react'
import { Link } from 'react-router-dom'
import { cn } from './cn'

export function PageHeader({ title, subtitle, breadcrumbs, actions, className }) {
  return (
    <div className={cn('mb-6', className)}>
      {breadcrumbs?.length > 0 && (
        <nav className="mb-2 flex flex-wrap items-center gap-1 text-sm text-text-muted dark:text-text-muted-dark">
          {breadcrumbs.map((crumb, index) => (
            <React.Fragment key={`${crumb.label}-${index}`}>
              {index > 0 && <span className="text-secondary-400">/</span>}
              {crumb.href ? (
                <Link to={crumb.href} className="hover:text-primary-600 dark:hover:text-primary-400">
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-secondary-700 dark:text-secondary-300">{crumb.label}</span>
              )}
            </React.Fragment>
          ))}
        </nav>
      )}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-secondary-900 dark:text-secondary-50 lg:text-3xl">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-text-muted dark:text-text-muted-dark">{subtitle}</p>}
        </div>
        {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </div>
  )
}
